(function () {
    'use strict';
    var controllerId = 'sezioneAddEdit';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'sezione', '$translate', sezioneAddEditFn]);

    function sezioneAddEditFn($rootScope, $scope, $uibModalInstance, $filter, datacontext, common, sezione, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.sezione = sezione;

        if ($scope.sezione.Id == 0) {
            $scope.titolo = $translate.instant('Nuovo centro di costo');
        }
        else {
            $scope.titolo = $translate.instant('Modifica centro di costo');
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                if ($scope.sezione.Id == 0) {
                    addItem($scope.sezione).then(function (result) {
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
                else {  
                    editItem($scope.sezione).then(function (result) {
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Modifica elemento
        function editItem(item) {
            return datacontext.sezione_update(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));
                    return null;
                }
                return data;                                                    
            });
        }

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.sezione_add(item).then(function (data) {                
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));
                    return null;
                }

                return data;                                                    
            });
        }
    }
})();